// extracted by mini-css-extract-plugin
export default {"root":"TableActions_root__5dfLQ","action":"TableActions_action__NIHMd","linkAction":"TableActions_linkAction__ye2zK"};